const TZ = "America/Caracas";

export function todayCcs() {
  return new Intl.DateTimeFormat("en-CA", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
}

const toDate = (s) => { const [y, m, d] = s.split("-").map(Number); return new Date(Date.UTC(y, m - 1, d)); };
const toStr = (dt) => dt.toISOString().slice(0, 10);
export const addDays = (s, n) => { const d = toDate(s); d.setUTCDate(d.getUTCDate() + n); return toStr(d); };
const monthStart = (s) => `${s.slice(0, 7)}-01`;
const monthEnd = (s) => { const d = toDate(s); return toStr(new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0))); };

// Semana operativa: lunes→domingo, recortada a los límites del mes.
export function weekBucket(s) {
  const wd = (toDate(s).getUTCDay() + 6) % 7;
  const mon = addDays(s, -wd);
  const sun = addDays(mon, 6);
  const ms = monthStart(s);
  const me = monthEnd(s);
  return [mon < ms ? ms : mon, sun > me ? me : sun];
}

export const PRESETS = [
  { key: "today", label: "Hoy" },
  { key: "yesterday", label: "Ayer" },
  { key: "this_week", label: "Esta semana" },
  { key: "last_week", label: "Semana pasada" },
  { key: "this_month", label: "Este mes" },
  { key: "last_month", label: "Mes pasado" },
  { key: "custom", label: "Personalizado" },
];

export function presetRange(key) {
  const t = todayCcs();
  if (key === "today") return [t, t];
  if (key === "yesterday") { const y = addDays(t, -1); return [y, y]; }
  if (key === "this_week") return weekBucket(t);
  if (key === "last_week") return weekBucket(addDays(weekBucket(t)[0], -1));
  if (key === "this_month") return [monthStart(t), monthEnd(t)];
  if (key === "last_month") { const p = addDays(monthStart(t), -1); return [monthStart(p), monthEnd(p)]; }
  return null;
}

function parts(iso) {
  const p = {};
  new Intl.DateTimeFormat("en-US", {
    timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "numeric", minute: "2-digit", hour12: true,
  }).formatToParts(new Date(iso)).forEach((x) => { p[x.type] = x.value; });
  return p;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const p = parts(iso);
  return `${p.day}/${p.month}/${p.year}`;
}

export function fmtTime(iso) {
  if (!iso) return "";
  const p = parts(iso);
  return `${p.hour}:${p.minute} ${p.dayPeriod}`;
}

export function fmtDateTime(iso) {
  return iso ? `${fmtDate(iso)} · ${fmtTime(iso)}` : "—";
}

export function fmtDayStr(s) {
  if (!s) return "Sin fecha";
  const d = toDate(s);
  const wd = new Intl.DateTimeFormat("es-VE", { weekday: "long", timeZone: "UTC" }).format(d);
  return `${wd.charAt(0).toUpperCase()}${wd.slice(1)} ${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)}`;
}

export const shortDay = (s) => (s ? `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)}` : "");

export function ccsDayOf(iso) {
  if (!iso) return null;
  const p = parts(iso);
  return `${p.year}-${p.month}-${p.day}`;
}

export function money(n) {
  if (n == null) return "—";
  const v = Number(n);
  return `$${v.toLocaleString("es-VE", { maximumFractionDigits: 2 })}`;
}

export const PRICE_LABEL = {
  final: "Precio final",
  approved: "Presupuesto aprobado",
  budget: "Presupuesto sin aprobar",
  none: "Sin presupuesto",
};

export const DATE_FIELD_LABEL = {
  received: "Fecha de recepción",
  finalized: "Reparación finalizada",
  pickup: "Retiro / entrega",
  activity: "Actividad del período",
};

export const deviceLabel = (r) => [r.subcategory_name, r.brand, r.model].filter(Boolean).join(" · ");
